import React from "react";
import { Edit, Trash2, Monitor, Smartphone } from "lucide-react";

const BannerList = React.memo(({ banners, onEdit, onDelete, loading }) => {

  //  LOADING 
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {[1, 2, 3, 4].map((n) => (
          <div
            key={n}
            className="p-4 bg-white rounded-xl shadow-sm border animate-pulse"
          >
            <div className="h-44 bg-gray-200 rounded-md mb-4" />
            <div className="h-4 w-1/2 bg-gray-200 rounded mb-2" />
            <div className="h-4 w-1/3 bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    );
  }

  //  EMPTY 
  if (!banners.length) {
    return (
      <div className="text-center py-16 text-gray-500">
        No banners added yet.
      </div>
    );
  }

  //  UI 
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {banners.map((banner) => (
        <div
          key={banner.id}
          className="bg-white rounded-xl shadow-sm border hover:shadow-md transition overflow-hidden"
        >
          {/* 🔥 PREVIEW (NO CROP, TRUE ASPECT) */}
          <div className="bg-gray-50 flex items-center justify-center p-3">
            {banner.videoUrl ? (
              <video
                src={banner.videoUrl}
                className="w-full max-h-64 object-contain rounded-md border"
                controls
              />
            ) : (
              <img
                src={banner.imageUrl}
                alt={banner.title}
                loading="lazy"
                className="w-full max-h-64 object-contain rounded-md border"
              />
            )}
          </div>

          {/* 🔥 CONTENT */}
          <div className="p-4 space-y-3">

            {/* TITLE + SEQUENCE */}
            <div className="flex items-center justify-between gap-2">
              <h3 className="text-sm md:text-base font-semibold text-gray-800 line-clamp-1">
                {banner.title}
              </h3>

              {/* SEQUENCE BADGE */}
              {banner.sequence !== undefined && banner.sequence !== 999 && (
                <span className="text-xs px-2 py-1 rounded bg-gray-100 text-gray-600">
                  #{banner.sequence}
                </span>
              )}
            </div>

            {/* DEVICE + STATUS */}
            <div className="flex items-center justify-between flex-wrap gap-2">

              {/* DEVICE */}
              <span
                className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${banner.device === "desktop"
                  ? "bg-blue-100 text-blue-700"
                  : "bg-green-100 text-green-700"
                  }`}
              >
                {banner.device === "desktop" ? (
                  <Monitor size={14} className="mr-1" />
                ) : (
                  <Smartphone size={14} className="mr-1" />
                )}
                {banner.device}
              </span>

              {/* STATUS */}
              <span
                className={`inline-flex px-3 py-1 text-xs rounded-full font-medium ${banner.active
                  ? "bg-green-100 text-green-700"
                  : "bg-gray-100 text-gray-600"
                  }`}
              >
                {banner.active ? "Active" : "Inactive"}
              </span>
            </div>

            {/* ACTIONS */}
            <div className="flex justify-end gap-2 pt-2">
              <button
                onClick={() => onEdit(banner)}
                className="p-2 rounded-md bg-indigo-50 hover:bg-indigo-100 text-indigo-600 transition"
              >
                <Edit size={18} />
              </button>

              <button
                onClick={() => onDelete(banner)}
                className="p-2 rounded-md bg-red-50 hover:bg-red-100 text-red-600 transition"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});

export default BannerList;